import axios from "axios";

const useSettingsProvider = () => {
  const listSettingsProvider = ({ page, page_size, search }) => {
    return axios({
      method: "get",
      url: "settings",
      params: { page, page_size, search }
    });
  };

  const getSettingProvider = (id) => {
    return axios({
      method: "get",
      url: `settings/${id}`,
    });
  };

  const createSettingProvider = (data) => {
    return axios({
      method: "post",
      url: "settings",
      data
    });
  };

  const updateSettingProvider = (id, data) => {
    return axios({
      method: "patch",
      url: `settings/${id}`,
      data
    });
  };

  const deleteSettingProvider = (id) => {
    return axios({
      method: "delete",
      url: `settings/${id}`,
    });
  };

  return {
    listSettingsProvider,
    getSettingProvider,
    createSettingProvider,
    updateSettingProvider,
    deleteSettingProvider,
  };
};

export default useSettingsProvider;
